"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.zBooleanQueryParam = void 0;
exports.zMultiValueQueryParam = zMultiValueQueryParam;
const zod_1 = require("zod");
/**
 * z.coerce.boolean() is a trap over the wire: Boolean("false") is `true`,
 * since any non-empty string is truthy in JS. A query string always
 * arrives as a string, so this parses the literal text instead. Shared
 * across every list/search endpoint's query schema — see customers.ts and
 * vehicles.ts.
 */
exports.zBooleanQueryParam = zod_1.z
    .union([zod_1.z.boolean(), zod_1.z.string()])
    .transform((value) => (typeof value === "boolean" ? value : value.toLowerCase() === "true"));
/**
 * Repeating the same query key (`?status=a&status=b`) is how a multi-select
 * filter travels over HTTP — Express's default `qs` parser already turns
 * that into an array on `req.query`, but a SINGLE value arrives as a plain
 * string, not a one-item array. Normalizes both shapes to always be an
 * array, so every list endpoint's service code only ever deals with one
 * shape (see InvoicesService.list()/WorkOrdersService.list()).
 */
function zMultiValueQueryParam(single) {
    return zod_1.z
        .union([single, zod_1.z.array(single)])
        .optional()
        .transform((value) => (value === undefined ? undefined : Array.isArray(value) ? value : [value]));
}
//# sourceMappingURL=query-params.js.map